import React from 'react';

const Notice = (props) => {

	return (
		<div className="notice">
			<h5>Great news</h5>
			<p>This month we are offering exciting new connection deals in your area.</p>
			<p className="bold">Call us now to find out more.</p>
		</div>
	);

};

export default Notice;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Notice.js